<template>
  <div id="app">
    <router-link :to="{path: '/home'}" class="wfeTitle"><h3>&nbsp;&nbsp;&nbsp;&nbsp;{{$t( msg )}}</h3></router-link>
    <br />

    <transition name="fade" mode="out-in">
    <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'app.home'
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.wfeTitle {
  color: purple;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/App.vue